/* ============================================================
   ELECTROSUR ILUMINA — Cart JS
   Archivo: assets/ei-cart.js
   ============================================================ */

/* ── ABRIR / CERRAR DRAWER ── */
function eiCartOpen() {
  document.getElementById('ei-cart-drawer').classList.add('open');
  document.getElementById('ei-cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function eiCartClose() {
  document.getElementById('ei-cart-drawer').classList.remove('open');
  document.getElementById('ei-cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

/* ── FETCH CARRITO ── */
async function eiGetCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

/* ── AÑADIR AL CARRITO (usado por botones ATC de producto) ── */
async function eiAddToCart(variantId, quantity = 1, openDrawer = true) {
  const btn = document.getElementById('eip-atc-btn');
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (!res.ok) throw new Error('Error al añadir');

    await eiRefreshDrawer();
    eiUpdateCartCount();

    if (openDrawer) eiCartOpen();

    if (btn) {
      btn.textContent = '✓ Añadido';
      btn.style.background = 'var(--ei-gold)';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'Añadir al carrito';
        btn.style.background = '';
      }, 1800);
    }
  } catch (err) {
    console.error('eiAddToCart error:', err);
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Añadir al carrito';
    }
  }
}

/* ── ACTUALIZAR CANTIDAD ── */
async function eiUpdateQty(key, qty) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await eiRefreshDrawer();
    eiUpdateCartCount();
  } catch (err) {
    console.error('eiUpdateQty error:', err);
  }
}

/* ── AÑADIR UPSELL ── */
async function eiAddUpsell(variantId, btn, itemId) {
  btn.disabled = true;
  btn.textContent = '…';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    // Ocultar el upsell añadido
    const el = document.getElementById(itemId);
    if (el) {
      el.style.transition = 'opacity 0.3s, transform 0.3s';
      el.style.opacity = '0';
      el.style.transform = 'translateX(10px)';
      setTimeout(() => el.remove(), 300);
    }

    await eiRefreshDrawerSilent();
    eiUpdateCartCount();

  } catch (err) {
    console.error('eiAddUpsell error:', err);
    btn.disabled = false;
    btn.textContent = '+';
  }
}

/* ── ACTUALIZAR CONTADOR HEADER ── */
async function eiUpdateCartCount() {
  try {
    const cart = await eiGetCart();
    const count = cart.item_count;

    // Badge en el header
    const badge = document.getElementById('ei-cart-count');
    if (badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
    }

    // Count en el drawer
    const drawerCount = document.getElementById('ei-drawer-count');
    if (drawerCount) {
      drawerCount.textContent = `(${count} ${count === 1 ? 'producto' : 'productos'})`;
    }

    // Barra de progreso
    eiUpdateShippingBar(cart.total_price);

    // Subtotal
    const subtotalEl = document.getElementById('ei-cart-subtotal');
    if (subtotalEl) {
      subtotalEl.textContent = eiFormatMoney(cart.total_price);
    }
  } catch (err) {
    console.error('eiUpdateCartCount error:', err);
  }
}

/* ── BARRA DE ENVÍO GRATIS ── */
function eiUpdateShippingBar(totalCents) {
  const threshold = window.eiShippingThreshold || 7900; // 79€ en céntimos
  const bar = document.getElementById('ei-progress-bar');
  if (!bar) return;

  const pct = Math.min(100, Math.round((totalCents / threshold) * 100));
  bar.style.width = pct + '%';

  const shippingBar = document.getElementById('ei-shipping-bar');
  if (!shippingBar) return;

  if (totalCents >= threshold) {
    shippingBar.innerHTML = '<div class="ei-cart__shipping-done">🎉 ¡Envío gratis desbloqueado!</div>';
  } else {
    const remaining = eiFormatMoney(threshold - totalCents);
    shippingBar.innerHTML = `
      <div class="ei-cart__shipping-text">
        <strong>Envío gratis</strong>
        <span>Te faltan ${remaining}</span>
      </div>
      <div class="ei-cart__progress-track">
        <div class="ei-cart__progress-bar" id="ei-progress-bar" style="width:${pct}%"></div>
      </div>
    `;
  }
}

/* ── REFRESCAR DRAWER (recarga sección via Shopify) ── */
async function eiRefreshDrawer() {
  try {
    const res = await fetch('/?sections=ei-cart-drawer');
    const data = await res.json();
    if (data['ei-cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data['ei-cart-drawer'], 'text/html');

      // Actualizar items
      const newItems = doc.getElementById('ei-cart-items');
      const curItems = document.getElementById('ei-cart-items');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      // Actualizar upsells
      const newUpsell = doc.getElementById('ei-upsell-items');
      const curUpsell = document.getElementById('ei-upsell-items');
      if (newUpsell && curUpsell) curUpsell.innerHTML = newUpsell.innerHTML;

      // Actualizar footer
      const newFooter = doc.querySelector('.ei-cart__footer');
      const curFooter = document.querySelector('#ei-cart-drawer .ei-cart__footer');
      if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;
    }
  } catch (err) {
    console.error('eiRefreshDrawer error:', err);
  }
}

/* Versión silenciosa (sin recargar sección completa, sólo actualiza totales) */
async function eiRefreshDrawerSilent() {
  try {
    const cart = await eiGetCart();
    eiUpdateShippingBar(cart.total_price);
    const subtotalEl = document.getElementById('ei-cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = eiFormatMoney(cart.total_price);
    const badge = document.getElementById('ei-cart-count');
    if (badge) { badge.textContent = cart.item_count; badge.setAttribute('data-count', cart.item_count); }
    const drawerCount = document.getElementById('ei-drawer-count');
    if (drawerCount) drawerCount.textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'producto' : 'productos'})`;
  } catch (err) {
    console.error('eiRefreshDrawerSilent error:', err);
  }
}

/* ── FORMATO MONEDA ── */
function eiFormatMoney(cents) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  }).format(cents / 100);
}

/* ── BOTÓN ATC EN PÁGINA DE PRODUCTO ── */
document.addEventListener('DOMContentLoaded', function () {

  // Botón añadir al carrito
  const atcBtn = document.getElementById('eip-atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const form = document.getElementById('eip-product-form');
      if (!form) return;
      const variantInput = document.getElementById('eip-variant-id');
      const qtyInput = document.getElementById('eip-qty');
      const variantId = variantInput ? parseInt(variantInput.value) : null;
      const qty = qtyInput ? parseInt(qtyInput.value) : 1;
      if (variantId) eiAddToCart(variantId, qty, true);
    });
  }

  // Botón comprar ahora
  const buyBtn = document.getElementById('eip-buy-btn');
  if (buyBtn) {
    buyBtn.addEventListener('click', async function () {
      const variantInput = document.getElementById('eip-variant-id');
      const qtyInput = document.getElementById('eip-qty');
      const variantId = variantInput ? parseInt(variantInput.value) : null;
      const qty = qtyInput ? parseInt(qtyInput.value) : 1;
      if (variantId) {
        await eiAddToCart(variantId, qty, false);
        window.location.href = '/checkout';
      }
    });
  }

  // Inicializar threshold de envío gratis
  const thresholdEl = document.querySelector('[data-shipping-threshold]');
  if (thresholdEl) {
    window.eiShippingThreshold = parseInt(thresholdEl.dataset.shippingThreshold) * 100;
  } else {
    window.eiShippingThreshold = 7900;
  }

  // Actualizar badge al cargar
  eiUpdateCartCount();
});

/* ── MINI NOTIFICACIÓN ATC (toast) ── */
function eiToast(msg, type = 'success') {
  const existing = document.getElementById('ei-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = 'ei-toast';
  toast.style.cssText = `
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%) translateY(20px);
    background: ${type === 'success' ? 'var(--ei-text)' : '#E24B4A'};
    color: #fff;
    padding: 0.8rem 1.5rem;
    font-family: var(--ei-sans);
    font-size: 0.78rem;
    font-weight: 400;
    letter-spacing: 0.04em;
    z-index: 9999;
    opacity: 0;
    transition: all 0.3s;
    pointer-events: none;
  `;
  toast.textContent = msg;
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(10px)';
    setTimeout(() => toast.remove(), 300);
  }, 2500);
}